import ConditionalTooltip from 'components/ConditionalTooltip';
import DepictMolecule from 'components/DepictMolecule';
import { SearchResultsGroup } from 'features/searchMolecules/searchMoleculesSlice';
import {
    addBatchToCart, getCurrentCart, removeBatchFromCart
} from 'features/shoppingCart/shoppingCartSlice';
import { useThunkDispatch } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { IconButton, Typography } from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';

interface Props {
  group: SearchResultsGroup;
  refmol: string;
  index?: number;
  isSelected: boolean;
}

const ResultGroupDetailView = ({ group, refmol, index, isSelected }: Readonly<Props>) => {
  const { t } = useTranslation(['common', 'results', 'groupClassifications']);
  const currentCart = useSelector(getCurrentCart);
  const dispatch = useThunkDispatch();

  const allInCart = group.members
    .map((member) => currentCart.items.map((item) => item.id).includes(member.id))
    .every((m) => m);

  const someInCart = group.members
    .map((member) => currentCart.items.map((item) => item.id).includes(member.id))
    .some((m) => m);

  const addAll = () => {
    if (!allInCart) {
      dispatch(
        addBatchToCart(
          group.members.map((member) => ({ ...member, isLoading: false, selectedItems: [] })),
        ),
      );
    }
  };

  const removeAll = () => {
    dispatch(
      removeBatchFromCart(
        currentCart.items
          .filter((item) => group.members.map((member) => member.id).includes(item.id))
          .map((item) => item.id),
      ),
    );
  };
  // console.log(group);

  return (
    <div>
      <DepictMolecule smiles={group.prototype} width={100} height={100} mcs={refmol} />
      <Typography display="block" variant="caption">
        {index !== undefined && index + 1}. {t(`groupClassifications:${group.classification}`)} (
        {group.members.length}/{group.memberCount})
      </Typography>
      {isSelected && (
        <>
          <ConditionalTooltip condition={!allInCart} title={t('results:add_all_cart')!}>
            <IconButton aria-label="add-all" onClick={addAll} disabled={allInCart}>
              <AddShoppingCartIcon fontSize="small" />
            </IconButton>
          </ConditionalTooltip>
          <ConditionalTooltip condition={someInCart} title={t('results:remove_all_cart')!}>
            <IconButton aria-label="remove-all" onClick={removeAll} disabled={!someInCart}>
              <RemoveShoppingCartIcon fontSize="small" />
            </IconButton>
          </ConditionalTooltip>
        </>
      )}
    </div>
  );
};

export default ResultGroupDetailView;
